import { Checkbox } from 'antd';
import styled from '@emotion/styled';
import React from 'react';
import VisuallyHidden from '@components/UI/utilities/VisuallyHidden';

export const StyledRequirementsContainer = styled.section`
  width: 100%;
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;

  h4 {
    margin-bottom: 1rem;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.06rem;
    color: var(--productGray);
  }
`;

export const RequirementsGrid = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 0;
  padding: 0;
  margin: 0;
  list-style: none;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const RequirementItem = styled.li`
  .ant-checkbox-wrapper {
    pointer-events: none;
  }

  .ant-checkbox-label {
    padding: 0;
  }

  .ant-checkbox-inner {
    border-radius: 50%;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #22c55e;
    border-color: #22c55e;
  }
`;

type RequirementItemProps = {
  description: string;
  ok: boolean;
};

const RequirementCheckbox = ({ description, ok }: RequirementItemProps) => (
  <RequirementItem>
    {/* Hide checkbox from screen readers */}
    <Checkbox checked={ok} tabIndex={-1} aria-hidden>
      {/* Provide text for screen reader */}
      <span style={{marginLeft: '8px'}}>
        {description}
        <VisuallyHidden>{ok ? " (Completed)" : ""}</VisuallyHidden>
      </span>
    </Checkbox>
  </RequirementItem>
);

type InputRequirementsProps = {
  title: string;
  id: string;
  inputRequirements: RequirementItemProps[];
};

const InputRequirements = ({ title, id, inputRequirements }: InputRequirementsProps) => (
  <StyledRequirementsContainer id={id}>
    <h4>{title}</h4>
    <RequirementsGrid>
      {inputRequirements.map((requirement) => (
        <RequirementCheckbox
          key={requirement.description}
          ok={requirement.ok}
          description={requirement.description}
        />
      ))}
    </RequirementsGrid>
  </StyledRequirementsContainer>
);

export default InputRequirements;
